<template>
	<div>
		<pui-datatable v-if="!masterDetail" :modelName="modelName" :modelColumnDefs="modelColumnDefs"
			:navigableDetail="false"></pui-datatable>
		<pui-datatable v-else :modelName="modelName" :modelColumnDefs="modelColumnDefs" :externalFilter="externalFilter"
			:masterDetail="masterDetail" :parentModelName="parentModelName" :modalDialog="modalDialog"
			:readOnly="readOnly" :showCreateBtn="showCreateBtn" :showDeleteBtn="showDeleteBtn"></pui-datatable>
	</div>
</template>

<script>
import { PuiGridDetailMixin } from '@Pui9Datatables';

export default {
	name: 'vehiculospartida-grid',
	components: {},
	mixins: [PuiGridDetailMixin],
	data() {
		return {
			modelName: 'vehiculospartida',
			modelColumnDefs: {}
		};
	}
};
</script>
